/**
 * Stops a failure inside Lou from taking the dashboard with it.
 *
 * The assistant renders inside the application shell, so an uncaught error in
 * a message, a widget or the realtime layer would unmount the tree it shares
 * with the charts. The product must not break because Lou does — this is the
 * wall that guarantees it.
 *
 * Deliberately a class: only class components can catch render errors.
 */

import React from "react";
import "./AssistantErrorBoundary.scss";

class AssistantErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // Logged rather than swallowed: the user sees a contained failure, and
    // whoever is on call still gets the stack.
    console.error("[Lou] Assistant crashed", error, info?.componentStack);
  }

  handleRetry = () => {
    this.setState({ failed: false });
  };

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="lou-crashed" role="alert">
        <p className="lou-crashed__title">Lou ran into a problem.</p>
        <p className="lou-crashed__body">
          The rest of the dashboard is unaffected. Your conversations are saved.
        </p>
        <button type="button" className="lou-crashed__retry" onClick={this.handleRetry}>
          Reload Lou
        </button>
      </div>
    );
  }
}

export default AssistantErrorBoundary;
